import { useEnvironmentVariables, useGetCurrentUserSuspenseQuery } from "@workleap-ai/shared";
import { setGlobalSpanAttributes } from "@workleap/honeycomb";
import { useEffect } from "react";

export const useOpenTelemetry = () => {
    const { data: { memberId, organizationId } } = useGetCurrentUserSuspenseQuery();
    const { aiApiBaseUrl } = useEnvironmentVariables();

    useEffect(() => {
        setGlobalSpanAttributes({
            memberId,
            organizationId
        });
    }, [aiApiBaseUrl, memberId, organizationId]);
};
